/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlResolutionRequestAttestation } from './ControlResolutionRequestAttestation';
import {
    ControlResolutionRequestAttestationFromJSON,
    ControlResolutionRequestAttestationFromJSONTyped,
    ControlResolutionRequestAttestationToJSON,
} from './ControlResolutionRequestAttestation';
import type { ControlResolutionRequestReason } from './ControlResolutionRequestReason';
import {
    ControlResolutionRequestReasonFromJSON,
    ControlResolutionRequestReasonFromJSONTyped,
    ControlResolutionRequestReasonToJSON,
} from './ControlResolutionRequestReason';
import type { ControlResolutionRequestStatus } from './ControlResolutionRequestStatus';
import {
    ControlResolutionRequestStatusFromJSON,
    ControlResolutionRequestStatusFromJSONTyped,
    ControlResolutionRequestStatusToJSON,
} from './ControlResolutionRequestStatus';
import type { ControlResolutionRequestUser } from './ControlResolutionRequestUser';
import {
    ControlResolutionRequestUserFromJSON,
    ControlResolutionRequestUserFromJSONTyped,
    ControlResolutionRequestUserToJSON,
} from './ControlResolutionRequestUser';

/**
 * 
 * @export
 * @interface ControlResolutionRequestResponse
 */
export interface ControlResolutionRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponse
     */
    request_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponse
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponse
     */
    entity_name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponse
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponse
     */
    org_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlResolutionRequestResponse
     */
    assets?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponse
     */
    datapoint: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponse
     */
    name?: string;
    /**
     * 
     * @type {ControlResolutionRequestReason}
     * @memberof ControlResolutionRequestResponse
     */
    reason?: ControlResolutionRequestReason;
    /**
     * 
     * @type {ControlResolutionRequestStatus}
     * @memberof ControlResolutionRequestResponse
     */
    status: ControlResolutionRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponse
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponse
     */
    updated: string;
    /**
     * 
     * @type {ControlResolutionRequestUser}
     * @memberof ControlResolutionRequestResponse
     */
    user?: ControlResolutionRequestUser;
    /**
     * 
     * @type {Array<ControlResolutionRequestAttestation>}
     * @memberof ControlResolutionRequestResponse
     */
    attestations?: Array<ControlResolutionRequestAttestation>;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestResponse
     */
    notes?: string;
}

/**
 * Check if a given object implements the ControlResolutionRequestResponse interface.
 */
export function instanceOfControlResolutionRequestResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "request_id" in value;
    isInstance = isInstance && "entity_id" in value;
    isInstance = isInstance && "entity_name" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "datapoint" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function ControlResolutionRequestResponseFromJSON(json: any): ControlResolutionRequestResponse {
    return ControlResolutionRequestResponseFromJSONTyped(json, false);
}

export function ControlResolutionRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlResolutionRequestResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'request_id': json['request_id'],
        'entity_id': json['entity_id'],
        'entity_name': json['entity_name'],
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'assets': !exists(json, 'assets') ? undefined : json['assets'],
        'datapoint': json['datapoint'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'reason': !exists(json, 'reason') ? undefined : ControlResolutionRequestReasonFromJSON(json['reason']),
        'status': ControlResolutionRequestStatusFromJSON(json['status']),
        'created': json['created'],
        'updated': json['updated'],
        'user': !exists(json, 'user') ? undefined : ControlResolutionRequestUserFromJSON(json['user']),
        'attestations': !exists(json, 'attestations') ? undefined : ((json['attestations'] as Array<any>).map(ControlResolutionRequestAttestationFromJSON)),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function ControlResolutionRequestResponseToJSON(value?: ControlResolutionRequestResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request_id': value.request_id,
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'client_id': value.client_id,
        'org_id': value.org_id,
        'assets': value.assets,
        'datapoint': value.datapoint,
        'name': value.name,
        'reason': ControlResolutionRequestReasonToJSON(value.reason),
        'status': ControlResolutionRequestStatusToJSON(value.status),
        'created': value.created,
        'updated': value.updated,
        'user': ControlResolutionRequestUserToJSON(value.user),
        'attestations': value.attestations === undefined ? undefined : ((value.attestations as Array<any>).map(ControlResolutionRequestAttestationToJSON)),
        'notes': value.notes,
    };
}

